import React, { type PropsWithChildren } from 'react';
import { StyleSheet, View, type StyleProp, type ViewStyle } from 'react-native';

import { useAppLayout } from '../../hooks/useAppLayout';
import type { WebWidgetCellProps } from './WebWidgetGrid';

type WebWidgetGridProps = PropsWithChildren<{
  style?: StyleProp<ViewStyle>;
}>;

/** Responsive dashboard grid — CSS grid avoids flex-wrap half-width overlap. */
export function WebWidgetGrid({ children, style }: WebWidgetGridProps) {
  const { widgetGap, columns } = useAppLayout();

  return (
    <View
      style={[
        styles.grid,
        {
          gap: widgetGap,
          // RNW accepts CSS grid via style objects on web.
          gridTemplateColumns: columns === 2 ? '1fr 1fr' : '1fr',
        } as object,
        style,
      ]}
    >
      {children}
    </View>
  );
}

/** Grid cell — use span="full" for charts and wide widgets. */
export function WebWidgetCell({
  children,
  span = 1,
  style,
}: WebWidgetCellProps & { style?: StyleProp<ViewStyle> }) {
  return (
    <View
      style={[
        styles.cell,
        span === 'full' && styles.cellFull,
        style,
      ]}
    >
      {children}
    </View>
  );
}

const styles = StyleSheet.create({
  grid: {
    width: '100%',
    display: 'grid',
  } as object,
  cell: {
    width: '100%',
    minWidth: 0,
  },
  cellFull: {
    gridColumn: '1 / -1',
  } as object,
});
